import React, { useState, useEffect } from "react";
import { Row, Col, notification } from "antd";
import UserDrawer from "../../components/drawer/UserDrawer";
import { IndividualConversationStyle } from "../../pages/myProfile/IndividualConversationStyle";
import { useNavigate, useLocation } from "react-router-dom";
import "../onboarding/UserOnboardingPage.css";
import "../../pages/myProfile/PreviousConversationsStyles";
import myFriendLogo from "../../assets/images/my-friend-logo.png";
import myFriendText from "../../assets/images/my_friend_text.svg";
import goBackButton from "../../assets/images/Go_Back.svg";
import ProfileIcon from "../../assets/images/Drawer_Image.svg";
import './VoiceSelection.css';
import { postRequest, getRequest } from "../../api";
import { getUserBots } from "../../api/Avatar";
import amyImage from '../../assets/images/my-friend-logo.png';
import arthurImage from '../../assets/images/my-frieind-logo2.svg';
import samImage from '../../assets/images/Sam_Logo.png';

const VoiceSelection = () => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { userId } = location.state || {};
    const [botsData, setBotsData] = useState({});

    const fetchBotsData = async () => {
        try {
            const response = await getUserBots();
            if (response.success) {
                setBotsData(response.data.reduce((acc, { botName, imageUrl }) => {
                    acc[botName] = imageUrl;
                    return acc;
                }, {}));
            }
        } catch (error) {
            console.error('Error fetching bot data:', error);
            notification.error({
                message: 'Error fetching bot data',
                description: error.message,
            });
        }
    };

    useEffect(() => {
        fetchBotsData();
    }, []);

    const openDrawer = () => {
        setIsDrawerOpen(true);
    };
    const closeDrawer = () => {
        setIsDrawerOpen(false);
    };
    const handleGoBackButton = () => {
        navigate("/landing-page");
    };

    const [selectedVoice, setSelectedVoice] = useState('Amy');

    useEffect(() => {
        const fetchAvatar = async () => {
            try {
                const response = await getRequest('/user/get-avatar');

                if (response.error) {
                    console.error("Error fetching avatar:", response.error);
                    setSelectedVoice('Amy');
                } else {
                    const avatar = response.avatar;
                    if (avatar === 'Amy' || avatar === 'Arthur' || avatar === 'Sam') {
                        setSelectedVoice(avatar);
                    } else {
                        setSelectedVoice('Amy');
                    }
                }
            } catch (error) {
                console.error("Error fetching avatar:", error);
                setSelectedVoice('Amy');
            }
        };


        fetchAvatar();
    }, [userId]);

    const handleConfirm = async () => {
        try {
            const response = await postRequest('/user/choose-avatar', {
                avatar: selectedVoice,
            });

            if (response.error) {
                notification.error({ message: 'Avatar Error', description: response.error, duration: 10 });
            } else {
                const botName = response.avatar;
                notification.success({ message: 'Avatar Success', description: 'Updated Avatar successfully!', duration: 10 });
                navigate("/voice-selection2", { state: { botName: botName, userId: userId } });
            }
        } catch (error) {
            console.error("Error updating avatar:", error);
            notification.error({ message: 'Avatar Update Failed', description: 'An unexpected error occurred.', duration: 10 });
        }
    };

    return (
        <>
            <Row className="onboarding-page-section">
                <Col flex="10%" className="go-back-button">
                    <button onClick={handleGoBackButton} className="button-styling">
                        <img src={goBackButton} alt="Go Back Button" />
                    </button>
                </Col>
                <Col flex="80%" className="my-friend-text">
                    <img src={myFriendText} alt="My Friend Text" />
                    <img style={IndividualConversationStyle.logoStyle} src={myFriendLogo} alt="my-friend-logo" />
                </Col>
                <Col flex="10%" className="search-button">
                    <img
                        src={ProfileIcon}
                        alt="Profile Icon"
                        onClick={openDrawer}
                        style={{ cursor: 'pointer' }}
                    />
                    {isDrawerOpen && (
                        <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
                    )}
                </Col>
            </Row>

            <Row justify={"center"}>
                {isDrawerOpen && (
                    <Col span={4}>
                        <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
                    </Col>
                )}
            </Row>

            <div className="voice-selection-container">
                <h2 className="voice-heading1">Choose Who You Want to Talk to:</h2>
                <div className="voice-card">
                    <div className="voice-cards">
                        <div
                            className={`voice-option ${selectedVoice === 'Amy' ? 'selected' : ''}`}
                            onClick={() => setSelectedVoice('Amy')}
                        >
                            <p className="voice-name">Amy - Female Voice</p>
                            <div>
                                <img
                                    src={botsData['Amy'] || amyImage} 
                                    alt="Arthur"
                                    className="voice-image"
                                    style={{ borderRadius: '50%' }}
                                />
                            </div>                               <button className="voice-button">
                                {selectedVoice === 'Amy' ? 'Chosen' : 'Choose'}
                            </button>
                        </div>

                        <div
                            className={`voice-option ${selectedVoice === 'Arthur' ? 'selected' : ''}`}
                            onClick={() => setSelectedVoice('Arthur')}
                        >
                            <p className="voice-name">Arthur - Male Voice</p>
                            <div>
                                <img
                                    src={botsData['Arthur'] || arthurImage} 
                                    alt="Amy"
                                    className="voice-image"
                                    style={{ borderRadius: '50%' }}
                                />
                            </div>                            <button className="voice-button">
                                {selectedVoice === 'Arthur' ? 'Chosen' : 'Choose'}
                            </button>
                        </div>

                        <div
                            className={`voice-option ${selectedVoice === 'Sam' ? 'selected' : ''}`}
                            onClick={() => setSelectedVoice('Sam')}
                        >
                            <p className="voice-name">Sam - Text Based</p>
                            <div>
                                <img
                                    src={botsData['Sam'] || samImage} 
                                    alt="Sam"
                                    className="voice-image"
                                    style={{ borderRadius: '50%' }}
                                />
                            </div>
                            <button className="voice-button">
                                {selectedVoice === 'Sam' ? 'Chosen' : 'Choose'}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="voice-confirm">
                    <button className='voice-confirm-btn' onClick={handleConfirm}>
                        Confirm
                    </button>
                </div>
            </div>
        </>
    );
}

export default VoiceSelection;
